import React from "react";
import { NavLink } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="notFound">
      <div className="notFound-content">
        <h2>Erreur 404</h2>
        <NavLink to="/">
          <h3>
            {/* Icône sur le site font awesome "cdnjs", copie du lien du site dans index.html  */}
            {/* Pour visualisée les icônes, taper "search" dans le moteur de recherche de "fontawesome.com/icons" */}
            Retour à l'accueil <i className="fas fa-home"></i>
          </h3>
        </NavLink>
      </div>
    </div>
  );
};

export default NotFound;
